export default __webpack_public_path__ + "static/media/mr-hood-winky.2d962c74.gif";